module.exports = __webpack_public_path__ + "static/media/4.a87a3432.jpeg";